var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "FormLabel" }, [
    _c("span", { staticClass: "font-medium" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _vm.isOptional
      ? _c("span", { staticClass: "text-muted ml-2" }, [
          _vm._v("\n    (" + _vm._s(_vm.$t("global.optional")) + ")\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }